import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogAction, DialogContext } from '@eforall/dashboard';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { EntrepreneurProspectDialogAlignedAcceleratorsPart } from './aligned-accelerators/aligned-accelerators.part';
import { EntrepreneurProspectDialogAlignedCommitmentsPart } from './aligned-commitments/aligned-commitments.part';
import { EntrepreneurProspectDialogApplicationsPart } from './applications/applications.part';
import { EntrepreneurProspectDialogCoursesPart } from './courses/courses.part';
import { EntrepreneurProspectDialogDataService } from './entrepreneur-prospect-dialog-data.service';
import { EntrepreneurProspectOverviewDialogPart } from './overview-content/overview-content-dialog.part';

@Component({
	selector: 'entrepreneur-prospect-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		TabStripModule,
		EntrepreneurProspectDialogAlignedAcceleratorsPart,
		EntrepreneurProspectDialogAlignedCommitmentsPart,
		EntrepreneurProspectOverviewDialogPart,
		EntrepreneurProspectDialogApplicationsPart,
		EntrepreneurProspectDialogCoursesPart
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './entrepreneur-prospect.dialog.html'
})

export class EntrepreneurProspectDialog implements OnInit {

	public dialogRef = inject(MatDialogRef<EntrepreneurProspectDialog>);
	public dialogContext: DialogContext<{ personId: number, accProspectId: number | undefined }> = inject(MAT_DIALOG_DATA);
	private dialogDataService = inject(EntrepreneurProspectDialogDataService);

	public dialogBodyHeight = computed(() => this.dialogContext.dimensions().bodyHeight);

	public readonly headerName = computed(() => {
		return this.dialogDataService.dialogData()?.details ? 'Prospect: ' + this.dialogDataService.dialogData()?.details?.fullName : 'Prospect';
	});

	async ngOnInit() {
		const data = this.dialogContext.data;
		if (data) {
			await this.dialogDataService.loadData(data.personId, data.accProspectId);
		}
	}


	public actions = computed<DialogAction[]>(() => {
		return [{
			id: 'close',
			cssClass: signal(undefined),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Close'),
			linkType: 'no-action',
			willCloseDialog: true,
		}]
	});

}